import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { GroupClient } from './types';
import * as yup from 'yup';
import { alphanumericRegex, regexOnlyNumber } from 'shell/constants/regex';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.GruppoQuery],
  create: [SystemAuthorizations.GruppoAdd],
  edit: [SystemAuthorizations.GruppoUpdate],
  delete: [SystemAuthorizations.GruppoDelete],
});

export const headCells: HeadCell<GroupClient, keyof GroupClient>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchemaGroupsFilter = yup.object({
  code: yup.string().nullable().notRequired().matches(regexOnlyNumber, 'Il campo è numerico'),
  description: yup
    .string()
    .nullable()
    .notRequired()
    .matches(alphanumericRegex, 'Il campo è alfanumerico'),
});
